
/************************
 ** Full screen function **
 ************************/
// Open Full screen
function openFullscreen(elem) {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) { /* Safari */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) { /* IE11 */
    elem.msRequestFullscreen();
  }
}
// close Full screen
function closeFullscreen(document) {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) { /* Safari */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) { /* IE11 */
    document.msExitFullscreen();
  }
}

//**** Full Screen Function **/

// let Element1 = document.getElementById("fullscreen-svg"),
//   Element2 = document.getElementById("play-now");

// if (Element1 && Element2) {
//   [Element1, Element2].forEach(function (element) {
//     let el = document.getElementById("container-iframe");
//     element.addEventListener("click", function () {
//       openFullscreen(el);
//     });
//   });
// }

let Element1 = document.getElementById("fullscreen-svg");
if (Element1) {
  Element1.addEventListener("click", function () {
    let el = document.getElementById("container-iframe");
    openFullscreen(el);
  });
}

/********************************
 *** Play Now Button Function ***
 *******************************/
let Selector = document.getElementById("overlay"),
  Target = document.getElementById("container-iframe");

if (Selector) {
  let clickSelector = document.querySelector("#overlay > button"),
    DataUrl = Selector.getAttribute('data-url');

  clickSelector.addEventListener('click', function () {
    // Selector.remove();
    let iframe = document.createElement("iframe");
    iframe.setAttribute("id", "game-iframe");
    iframe.setAttribute("src", DataUrl);
    iframe.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture; fullscreen");
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("scrolling", "no");
    iframe.setAttribute("style", "width:100%; height:100%; border:none; overflow:hidden;");
    Target.prepend(iframe);
    Selector.remove();
  });
}

/****************************
 ** Scroll To Top Function **
 ****************************/
window.addEventListener("scroll", function () {
  if (document.documentElement.scrollTop <= 800) {
    document.getElementById("scroll-top").style.display = 'none';
  } else {
    document.getElementById("scroll-top").style.display = 'block';
  }
});

/*************************
 * Copy Text Function *****
 ************************/
function clickToCopy() {
  // Get the text field
  let copyText = document.getElementById("share-input");

  // Select the text field
  copyText.select();
  copyText.setSelectionRange(0, 99999); // For mobile devices

  // Copy the text inside the text field
  navigator.clipboard.writeText(copyText.value);
}
if (document.getElementById("click-to-copy")) {
  document.getElementById("click-to-copy").addEventListener("click", clickToCopy);
}


/*****************************
 * Social Share Function *****
 *****************************/
// Variables
let allButtons = document.querySelectorAll("#share-button")
  , facebookUrl = "https://www.facebook.com/sharer/sharer.php?u=" + document.URL + "&quote=" + document.title
  , twitterUrl = "https://twitter.com/share?url=" + document.URL + "&text=" + document.title
  , whatsappUrl = "https://web.whatsapp.com/send?text=" + document.title + " " + document.URL
  , linkedinUrl = "https://linkedin.com/shareArticle?url=" + document.URL + "&mini=true&title=" + document.title
  , redditUrl = "https://www.reddit.com/submit?url=" + document.URL + "&title=" + document.title
  , pinterestUrl = "http://pinterest.com/pin/create/link/?url=" + document.URL
  , screenOption = "width=660,height=460,left=350,top=150";
// Function
allButtons.forEach(function (elem) {
  elem.addEventListener("click", function () {
    if (elem.getAttribute('aria-label') == "facebook") {
      window.open(facebookUrl, '_blank', screenOption);
    } else if (elem.getAttribute('aria-label') === "twitter") {
      window.open(twitterUrl, '_blank', screenOption);
    } else if (elem.getAttribute('aria-label') === "linkedin") {
      window.open(linkedinUrl, '_blank', screenOption);
    } else if (elem.getAttribute('aria-label') === "reddit") {
      window.open(redditUrl, '_blank', screenOption);
    } else if (elem.getAttribute('aria-label') === "whatsapp") {
      window.open(whatsappUrl, '_blank', screenOption);
    } else if (elem.getAttribute('aria-label') === "pinterest") {
      window.open(pinterestUrl, '_blank', screenOption);
    }
  });
});

/****************
 * Ajax Report
 *****************/
if (document.getElementById('report-form')) {
  const form = document.getElementById('report-form'),
    thanksMessage = document.getElementById("thanksMessageModal"),
    formModal = document.getElementById("reportModal"),
    modalBackdrop = document.querySelector(".modal-backdrop"),
    sendButton = document.getElementById("report-button");
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    sendButton.disabled = true;
    const formData = new URLSearchParams(new FormData(this));
    const options = {
      method: "POST",
      body: formData
    };
    fetch(this.action, options)
      .then(response => {
        // return response.text();
        return response.text();
      })
      .then(html => {
        const reportModalClose = document.getElementById("reportModalClose"),
          thanksMessageModalOpen = document.getElementById("thanksMessageModalOpen"),
          thanksMessageModalClose = document.getElementById("thanksMessageModalClose"),
          reportModalFormControlTextarea = document.getElementById("reportModalFormControlTextarea");
        reportModalClose.click();
        thanksMessageModalOpen.click();
        reportModalFormControlTextarea.value = "";
        sendButton.disabled = false;
        // Remove after 3 seconds
        setTimeout(() => {
          thanksMessageModalClose.click();
        }, 2000);

      })
      .catch(error => {
        console.error(error);
      });
  });
}

/****************
 * Add Css to Iframe Child ruffle-embed
 *****************/
// if (document.getElementById('game-iframe')) {
//   document.getElementById('game-iframe').addEventListener('load', function () {
//     var iframeDocument = this.contentDocument || this.contentWindow.document;
//     var styleElement = iframeDocument.createElement('style');
//     styleElement.type = 'text/css';
//     styleElement.innerHTML = 'ruffle-embed {min-height: 100vh;width: 100%;} body {margin: 0}';
//     iframeDocument.head.appendChild(styleElement);
//   });
// }